export default {

  setUsers(state, data) {
    state.users = data;
  },
  setUser(state, data) {
    state.user = data;
  },

  setConfig(state, data) {
    state.config = data;
  },

  setMenus(state, data) {
    state.menus = data;
  },
};
